import { selectAllEntities, selectEntities } from '@hozana/api/selectors'

import type { TState } from 'config/types'

import type { TTag } from './types'

export const selectTags = (state: TState, tagsArray: number[]): TTag[] => selectEntities(state, 'tag', tagsArray)

export const selectAllTags = (state: TState): TTag[] => selectAllEntities(state, 'tag')
